// @flow
export { default } from './PostContent';



// WEBPACK FOOTER //
// ./src/components/post/PostContent/index.js